import _memoize from 'lodash/memoize';
import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { TERTIARY, PRIMARY, SECONDARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { WIDTH, EXPANDED_WIDTH } from '../sidenav.constants';
import { identity } from '../../tornado/utils/sizes';
import { cacheResolver, makeDefaultStylingContext } from '../../tornado/utils/style';
import { IMAGE_SIZE, ICON_SIZE, colors as iconColors } from '../customer/default/sidenavIcon/sidenavIcon.style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(PRIMARY),
  label: makeThemeColor(PRIMARY),
  focusedLabel: makeThemeColor(TERTIARY),
  indicator: makeThemeColor(SECONDARY),
};

export const ALPHA_INACTIVE = 0.3;

export const ALPHA_ACTIVE = 1;

export const HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 72,
};

// Padding between icon and label
export const ICON_PADDING = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const INDICATOR_WIDTH = {
  [HD]: 4,
  [FULL_HD]: 8,
};

export const getIndicatorPosition = (value, screenSize) =>
  (value ? EXPANDED_WIDTH[screenSize] : WIDTH[screenSize]) - INDICATOR_WIDTH[screenSize];

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const offset = safetyMargins.horizontal[screenSize];
  const font = getFont(FONT.OTTAWA_2, screenSize);
  const iconSize = ICON_SIZE[screenSize];
  const imageOffset = (IMAGE_SIZE[screenSize] - iconSize) / 2;

  return {
    h: HEIGHT[screenSize],
    alpha: ALPHA_INACTIVE,
    Background: {
      w: identity,
      h: HEIGHT[screenSize],
      alpha: 0,
      color: colors.background[colorMode],
    },
    Indicator: {
      alpha: 0,
      rect: true,
      h: HEIGHT[screenSize],
      w: INDICATOR_WIDTH[screenSize],
      x: getIndicatorPosition(false, screenSize),
      color: colors.indicator[colorMode],
    },
    Label: {
      text: {
        ...font,
        verticalAlign: 'middle',
      },
      alpha: 0,
      x: offset + iconSize + imageOffset + ICON_PADDING[screenSize],
      y: Math.round((HEIGHT[screenSize] - font.lineHeight) / 2),
    },
  };
};

export const getStateStyles = _memoize(
  ({ colorMode, screenSize }) => ({
    unfocused: {
      w: WIDTH[screenSize],
      Background: {
        w: WIDTH[screenSize],
        alpha: 0,
      },
      SidenavIcon: { Icon: { color: iconColors.icon[colorMode] } },
      Label: { color: colors.label[colorMode] },
    },
    focused: {
      alpha: ALPHA_ACTIVE,
      w: EXPANDED_WIDTH[screenSize],
      Background: {
        w: EXPANDED_WIDTH[screenSize],
        alpha: 1,
      },
      SidenavIcon: { Icon: { color: iconColors.focusedIcon[colorMode] } },
      Label: { color: colors.focusedLabel[colorMode] },
    },
  }),
  cacheResolver,
);
